module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "services-contacts view"
  }, [_c('div', {
    staticClass: "contacts"
  }, _vm._l((_vm.contacts), function(contact) {
    return _c('div', {
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "profil"
    }, [_c('img', {
      attrs: {
        "src": contact.imgSrc,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(contact.name)
      }
    }), _vm._v(" "), (contact.skills) ? _c('div', {
      staticClass: "skills",
      domProps: {
        "textContent": _vm._s(contact.skills)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "coordinates"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + contact.coordinates.phone
      },
      domProps: {
        "textContent": _vm._s(contact.coordinates.phone)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'tel:' + contact.coordinates.mobile
      },
      domProps: {
        "textContent": _vm._s(contact.coordinates.mobile)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'mailto:' + contact.coordinates.mail
      },
      domProps: {
        "textContent": _vm._s(contact.coordinates.mail)
      }
    })])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0e79caa4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/Contacts.vue
// module id = 64
// module chunks = 0